var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-player',{staticClass:"video-player vjs-custom-skin",attrs:{"options":_vm.playerOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }